import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";
import styled from "styled-components";

import { Clickable, Middle, Spacing, Text, WttjLogo } from "@otta/design";
import { pxToRem } from "@otta/design-tokens";

interface ConfirmProps {
  user: {
    firstName: string;
    lastName: string;
    email: string;
    externalId: string;
  };
  onUseOther(): void;
}

const StyledWttjLogo = styled(WttjLogo)`
  max-width: ${pxToRem(100)};
`;

export function Confirm({
  user,
  onUseOther,
}: ConfirmProps): React.ReactElement {
  const [searchParams] = useSearchParams();

  const handleConfirm = useCallback(() => {
    const nextQueryParams = new URLSearchParams(searchParams);

    nextQueryParams.set("uid", user.externalId);

    const url = `${
      import.meta.env.VITE_API_HOST
    }/auth/oauth2/authorize?${nextQueryParams.toString()}`;

    window.location.assign(url);
  }, [searchParams, user.externalId]);

  return (
    <Middle>
      <Spacing size={5}>
        <Spacing size={-2}>
          <StyledWttjLogo />
          <Text size={3}>Choose an account</Text>
        </Spacing>
        <Clickable
          onClick={handleConfirm}
          style={{ textAlign: "left", width: "100%" }}
        >
          <Text as="span" bold data-cs-mask>
            {user.firstName} {user.lastName}
          </Text>
          <br />
          <Text as="span" size={-1} data-cs-mask>
            {user.email}
          </Text>
        </Clickable>
        <Clickable
          onClick={onUseOther}
          style={{ textAlign: "left", width: "100%" }}
        >
          <Text as="span" bold>
            Use another account
          </Text>
        </Clickable>
      </Spacing>
    </Middle>
  );
}
